import { React, useEffect, useState, useRef, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { motion } from 'framer-motion';
import Table from 'react-bootstrap/Table';
import "./index.scss";

import ProfileAvatar from "../../../ui/ProfileAvatar";
import Pagination from "../../../ui/Pagination";
import RadioButton from "../../../ui/RadioButton";
import Button from "../../../ui/Button";
import SideModal from '../../../ui/SideModal';
import NoDataFound from "../../../ui/NoDataFound";
import DropDown from "../../../ui/DropDown/index.js";
import { toaster } from "../../../ui/Toaster/index.js";
import SkeletonLoader from "../../../ui/SkeletonLoader/index.js";


import AddDomain from "../AddDomain";
import ModifyDomain from "../ModifyDomain";

import EditPermissionModal from "../../CustomerDetails/EditPermissionModal";

import { editIcon, filterIcon, filterCloseIcon, searchIcon } from "../../../../utils/icons.js";
import { formatDate, getDomainImageUrl, getloggedInUserType, getUserImageUrl } from "../../../../utils/util.js";

import { useSelector, useDispatch } from 'react-redux';
import { getDomainListByOrganization, resetAddDomainResponse, resetDomainList, resetAssignUnassignResponse } from '../../../../store/actions/organizationActions.js';
import { getPermissionDetails } from "../../../../store/actions/customerAction.js";


const sortByOption = [
    {
        label: "Name",
        value: "name"
    },
    {
        label: "Domain",
        value: "domain"
    },
    {
        label: "Created At",
        value: "created_at"
    },
    {
        label: "Updated At",
        value: "updated_at"
    }
]

const filterRadioOption = [    
    {
        label: "Ascending",
        value: "asc"
    },
    {
        label: "Descending",
        value: "desc"
    }
]


const DomainTab = ({organizationDetail = "", customerDetails="", currentPageType="organizationDetails"}) => {

    const domainListResponse = useSelector((state) => state.organization?.domainListByOrganization);
    const addDomainResponse = useSelector((state) => state.organization?.addDomainResponse);
    const assignUnAssignResponse = useSelector((state) => state.organization?.assignUnAssignResponse);
    const permissionDetailResponse = useSelector((state) => state?.customer?.permissionDetailResponse);

    const dispatch = useDispatch();

    const { t } = useTranslation();

    // const navigate = useNavigate();

    const { customerId } = useParams();

    const filterWrapperRef = useRef(null);
    //search value
    const [domainSearchValue, setDomainSearchValue] = useState("");
    const [domainSearchedValue, setDomainSearchedvalue] = useState("");
    const [isDomainSearchFocused, setIsDomainSearchFocused] = useState(false);
    //filter value
    const [selectedSortby, setSelectedSortBy] = useState("");
    const [selectedSortOrder, setSelectedSortOrder] = useState("");    
    const [showFilter, setShowFilter] = useState(false);

    //selected filter value
    const [filterSelectedSortby, setFilterSelectedSortby] = useState("");
    const [filterSelectedSortOrder, setFilterSelectedSortOrder] = useState("");

    const [showAdddomainSidePanel, setShowAdddomainSidePanel] = useState(false);
    const [showModifySidePanel, setShowModifySidePanel] = useState(false);
    const [domainListState, setDomainListState] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [showEditPermissionModal, setShowEditPermissionModal] = useState(false);
    const [selectedDomain, setSelectedDomain] = useState({});
    

    const applyFilter = () => {
        setCurrentPage(1);
        setFilterSelectedSortby(selectedSortby)
        setFilterSelectedSortOrder(selectedSortOrder)
        setShowFilter(false);
    }

    const removeFilter = (type) => {
        setCurrentPage(1);
        if (type === "sortorder") {
            setSelectedSortOrder("");
            setFilterSelectedSortOrder("")
        } else if (type === "sortby") {
            setSelectedSortBy("");
            setSelectedSortOrder("");
            setFilterSelectedSortby("")
            setFilterSelectedSortOrder("")
        }        
    }

    const filterClicked = () => {
        setShowFilter(true)
    }

    const sorbyChange = (data) => {
        setSelectedSortBy(data.value)
    }

    const sortOrderChange = (data) => {
        setSelectedSortOrder(data)
    }

    const displaySortByName = (type) => {
        if(type === "sortOrder") {
            const matchedOption = filterRadioOption.find((data) => data.value === selectedSortOrder)
            return matchedOption ? matchedOption.label : "";
        } else {
            const matchedOption = sortByOption.find((data) => data.value === selectedSortby)
            return matchedOption ? matchedOption.label : "";
        }       
    }

    const closeAddDomainSidePanel = () => {
        setShowAdddomainSidePanel(false)
    }

    const closeModifySidePanel = () => {
        setShowModifySidePanel(false)
    }

    const closeModifyModal = () => {
        closeModifySidePanel()
        dispatch(resetAssignUnassignResponse());
        if(assignUnAssignResponse?.detail?.status === "success") {
            setIsLoading(true)
            dispatch(resetDomainList())
            fetchDomain()
        }
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isDomainSearchFocused) {
            searchDomain()
        }
    }

    const searchDomain = () => {
        setCurrentPage(1);
        setDomainSearchedvalue(domainSearchValue)
    }

    const fetchDomain = useCallback(()=>{
        if(currentPageType === "organizationDetails") {
            const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&organization_id=${organizationDetail?.organization_id}`;
            const queryParams = domainSearchedValue ? `&query=${domainSearchedValue}` : "";
            const sortParams = (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
            const url = `${baseUrl}${queryParams}${sortParams}`;
            if(organizationDetail?.organization_id) {
                dispatch(getDomainListByOrganization(url, "list"));
            }            
        } else {
            const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}&customer_id=${customerDetails?.customer_id}`;
            const queryParams = domainSearchedValue ? `&query=${domainSearchedValue}` : "";
            const sortParams = (filterSelectedSortby ? `&sort_by=${filterSelectedSortby}` : '') + (filterSelectedSortOrder ? `&sort_order=${filterSelectedSortOrder}` : '');
            const url = `${baseUrl}${queryParams}${sortParams}`;
            if(customerDetails?.customer_id) {
                dispatch(getDomainListByOrganization(url, "list"));
            }           
        }
    },[currentPage, currentPageSize, dispatch, organizationDetail, customerDetails, currentPageType, domainSearchedValue, filterSelectedSortby, filterSelectedSortOrder])


    const closeAddDomain = () => {
        closeAddDomainSidePanel()
        if(addDomainResponse != null) {
            if(addDomainResponse?.detail?.status === "success") {
                setIsLoading(true)
                fetchDomain()
                dispatch(resetAddDomainResponse())
            }
        }
    }

    const editPermission = (data) => {        
        setSelectedDomain(data);
        const obj = {
            customer_id: customerId,
            domain: data.domain,
        };
        dispatch(getPermissionDetails(obj));
    }

    const getScoreStatus = (data) => {
        const score = data?.stats?.score?.latest_score?.overall_score?.obtained_score;
        if (score == null) return undefined;
        if (score >= 800) return 'low';
        if (score >= 500) return 'medium';
        if (score >= 250) return 'high';
        return 'critical';
    }
    
    useEffect(()=>{
        setIsLoading(true)
        fetchDomain()
    },[fetchDomain])

    useEffect(()=>{
        if(domainListResponse !== null){
            setDomainListState(domainListResponse)
            setIsLoading(false)
            dispatch(resetDomainList())
        }
    },[domainListResponse, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        
        }
    },[showFilter])

    useEffect(() => {
        if (permissionDetailResponse !== null) {
            if(permissionDetailResponse?.status === "failed"){
                toaster.addToast(permissionDetailResponse?.description, "success")
            } else {
                setShowEditPermissionModal(true)
            }            
        }
    }, [permissionDetailResponse, dispatch]);

    return (
        <>
            <div className="search-filter-container my-3 d-flex justify-content-between align-items-center">
                <div className="search-container d-flex align-items-center gap-3">
                    <div className="position-relative" onKeyDown={handleSearchKeyDown}>
                        <input className="search-input rounded" 
                            placeholder="Search Domains" 
                            value={domainSearchValue} 
                            onChange={(e)=>setDomainSearchValue(e.target.value)} 
                            onFocus={() => setIsDomainSearchFocused(true)}
                            onBlur={() => setIsDomainSearchFocused(false)}
                        />
                        <span className="position-absolute search-icon">{searchIcon()}</span>
                    </div>
                    <button className="search-btn" onClick={()=>{searchDomain()}}>{t("organizationDetailsPage.searchBtn")}</button>
                    <div className="position-relative">
                        <span className="filter-icon" onClick={filterClicked}>{filterIcon()}</span>
                        {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                            <h6>{t("organizationDetailsPage.domainTable.sortBy")}</h6>
                            <DropDown 
                                placeHolder={"Sort by"}
                                options={sortByOption}
                                isMulti={false}
                                isSearchable={false}
                                onChange={sorbyChange}
                                defaultSelectedValue={selectedSortby}
                            />
                            <h6 className="mt-4">Sort Order</h6>
                            <div className="filter-user-status d-flex mb-4 gap-4">
                                {
                                    filterRadioOption.map((data,index)=>{
                                        return (
                                            <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={sortOrderChange} key={index} isChecked={data.value === selectedSortOrder} />
                                        )
                                    })
                                }
                            </div>
                            <div className="filter-apply-btn mt-3">
                                <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={selectedSortby === "" || selectedSortOrder === ""} buttonClicked={()=>{applyFilter()}}/>
                            </div>
                        </div>}
                    </div>
                    {!showFilter && <p className="selected-filters">
                        {filterSelectedSortby !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortby")} <span onClick={() => removeFilter("sortby")}>{filterCloseIcon()}</span></span>}
                        {filterSelectedSortOrder !== "" && <span className="d-inline-block mx-2">{displaySortByName("sortOrder")} <span onClick={() => removeFilter("sortorder")}>{filterCloseIcon()}</span></span>}
                    </p>}
                </div>
                <div className="sort-edit-container">
                    <div className="container d-flex gap-3 align-items-center">                        
                        <button className="edit-btn" onClick={()=>{
                            setShowModifySidePanel(true)
                        }}>
                            <p className="d-inline-block mx-1">{editIcon()}</p>
                            {t("organizationDetailsPage.modifyBtn")}
                        </button>
                        {/* <button onClick={()=>{setShowAdddomainSidePanel(true)}}>
                            <img src={addIcon} alt="delete" className="d-inline-block mx-1" />
                            {t("organizationDetailsPage.domainBtn")}
                        </button> */}
                    </div>
                </div>
            </div>
            <div className="domain-table-container">

                {
                    isLoading ?
                    <SkeletonLoader type={"line"} count={5} currentPage={"domainTab"} />
                    :
                    <Table responsive="lg">
                        <thead>
                            <tr>
                                <th>{t("organizationDetailsPage.domainTable.domainDetails")}</th>
                                <th>{t("organizationDetailsPage.domainTable.createdBy")}</th>
                                <th>{t("organizationDetailsPage.domainTable.scanProgress")}</th>
                                <th>{t("organizationDetailsPage.domainTable.score")}</th>
                                <th>{t("organizationDetailsPage.domainTable.lastScan")}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                domainListState?.results.length > 0 &&
                                domainListState?.results.map((data,index)=>{
                                    return (
                                        <motion.tr
                                            key={index}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                        >
                                            <td>
                                                <ProfileAvatar type="domain" name={data?.domain} imageUrl={getDomainImageUrl(data)} secondaryText={`Created On : ${formatDate(data?.created_at)}`}/>
                                            </td>
                                            <td className="created-by-details">
                                                <ProfileAvatar type="profile" firstName={data?.created_by?.name} lastName={""} imageUrl={getUserImageUrl(data?.created_by)} secondaryText={`${data?.created_by?.role} | ${data?.created_by?.user_type || ""}`}/>
                                            </td>
                                            <td>
                                                {data?.scan_queue_detail?.scan_status === "completed" && <div className="scan-progress">
                                                    <div className="completed"> 
                                                        <div>Completed</div> 
                                                    </div>
                                                </div>}
                                                {data?.scan_queue_detail?.scan_status === "new" && <div className="scan-progress">
                                                    <div className="new"> 
                                                        <div>New</div> 
                                                    </div>
                                                </div>}
                                                {data?.scan_queue_detail?.scan_status === "pending" && <div className="scan-progress queued">
                                                    <h4>Queued - {data?.scan_queue_detail?.scan_percentage}%</h4>
                                                    <div className="progress-container"> 
                                                        <div style={{width:`${data?.scan_queue_detail?.scan_percentage}%`}}></div> 
                                                    </div>
                                                </div>}
                                                {data?.scan_queue_detail?.scan_status === "stopped" && <div className="scan-progress queued">
                                                    <h4>Stopped - {data?.scan_queue_detail?.scan_percentage}%</h4>
                                                    <div className="progress-container"> 
                                                        <div style={{width:`${data?.scan_queue_detail?.scan_percentage}%`}}></div> 
                                                    </div>
                                                </div>}
                                                {data?.scan_queue_detail?.scan_status === "in_progress" && <div className="scan-progress inprogress">
                                                    <h4>{data?.scan_queue_detail?.scan_percentage}%</h4>
                                                    <div className="progress-container"> 
                                                        <div style={{width:`${data?.scan_queue_detail?.scan_percentage}%`}}></div> 
                                                    </div>
                                                </div>}
                                            </td>
                                            <td>
                                                <span className={getScoreStatus(data)}>{data?.stats?.score?.latest_score?.overall_score?.obtained_score}</span> / {data?.stats?.score?.latest_score?.overall_score?.max_score}
                                            </td>
                                            <td>
                                                <p>{data?.last_scan_detail?.created_at !== null ? formatDate(data?.last_scan_detail?.created_at) : "-"}</p>
                                            </td>
                                            <td>
                                                <div className="d-flex gap-4">
                                                    {/* <p className="view-scan" onClick={()=>{
                                                        navigate(`/scan-info/exposure/dashboard?customer=all&organization=all&domain=${data?.domain}&scanId=${data?.last_scan_detail?.scan_id}`)
                                                    }}>{t("organizationDetailsPage.domainTable.viewScan")}{sendIcon()}</p> */}
                                                    {getloggedInUserType() === "internal" && <p className="view-scan" onClick={()=>{
                                                        editPermission(data)
                                                    }}>{t("organizationDetailsPage.domainTable.editPermission")}{editIcon()}</p>}
                                                </div>
                                            </td>
                                        </motion.tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                }
                {
                    !isLoading && domainListState?.results.length === 0 &&
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <NoDataFound />
                    </motion.div>                    
                }
                {domainListState !== null && !isLoading && domainListState?.meta?.total_results !== 0 && <Pagination
                     className="pagination-bar"
                     currentPage={currentPage}
                     pageSize={currentPageSize}
                     totalCount={domainListState?.meta.total_results ? domainListState?.meta?.total_results : 0}
                     onPageChange={setCurrentPageandRecordSize}
                />}
            </div>
            <SideModal showSidePanel={showAdddomainSidePanel} hideSidePanel={closeAddDomainSidePanel}>
                {showAdddomainSidePanel && <AddDomain closeAddDomain={closeAddDomain}/>}
            </SideModal>
            <SideModal showSidePanel={showModifySidePanel} hideSidePanel={closeModifyModal}>
                {showModifySidePanel && <ModifyDomain selectedTab={"domain"} clsoeModifyModal={closeModifyModal} customerDetails={customerDetails} organizationDetail={organizationDetail} currentPageType={currentPageType}/>}
            </SideModal>
            <EditPermissionModal show={showEditPermissionModal} onHide={()=>{setShowEditPermissionModal(false)}} selectedDomain={selectedDomain} />
        </>
    )
}

export default DomainTab;